<script setup lang="ts">
import RegisterModalContent from '@/components/DailyReportEdit/Combine/RegisterModalContent.vue';
import RegisterModal from '@/components/Common/RegisterModal.vue';
import { computed } from 'vue';
import i18n from '@/lang/i18n';

const emits = defineEmits(['update:modelValue']);

const props = defineProps<{
  modelValue: boolean
  title: string
  combineItems: {
    driverName: string;
    start: Date | string;
    end: Date | string;
  }
  execCombine: () => void
}>();

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

function exec() {
  props.execCombine();
  modelValue.value = false;
}
</script>
<template>
  <RegisterModal
    v-model="modelValue"
    modalMaxWidth="20%"
    width="150px"
    :title="props.title"
  >
    <template v-slot:content>
      <RegisterModalContent
        :combineItems="props.combineItems"
      />
    </template>
    <template v-slot:buttons>
      <v-btn
        class="ma-2 reset-btn"
        @click="modelValue = false"
      >
        {{ i18n.global.t('common.cancelBtn') }}
      </v-btn>
      <v-btn
        class="ma-2 exec-btn"
        @click="exec"
      >
        {{ i18n.global.t('pages.dailyReports.combineForm.registerModal.execBtn') }}
      </v-btn>
    </template>
  </RegisterModal>
</template>
